import { loadGTM } from '../lib/funnels/functions/v1/default/gtm'

window.addEventListener('load', () => {
  // @ts-ignore
  window.Trustpilot?.loadFromElement(
    document.getElementById('trustpilot-grid'),
    true,
  )

  loadGTM('GTM-KZ525569')
})
